/*
 *
 * Reports constants
 *
 */

export const DEFAULT_ACTION = 'src/Reports/DEFAULT_ACTION';
